import React from "react";
function ProductFilter() {
  return (
    <>
      <div className="canvas-sidebar filter-canvas">
        <div className="canvas-overlay"></div>
        <form className="h-100">
          <div className="card border-0 pt-5 pb-8 pb-sm-13 h-100">
            <div className="px-6 pl-sm-8 text-right">
              <span className="canvas-close d-inline-block text-right fs-24 mb-1 ml-auto lh-1 text-primary">
                <i className="fal fa-times"></i>
              </span>
            </div>
            <div className="card-header bg-transparent py-0 px-6 px-sm-8 border-bottom">
              <h3 className="fs-30 mb-5">Filter by</h3>
              <p className="fs-15 text-primary mb-3">12 Products in “ Shop All ”</p>
            </div>
            <div className="card-body px-6 px-sm-8 pt-7 overflow-y-auto">
              <div className="card border-0 mb-7">
                <div className="card-header bg-transparent border-0 p-0">
                  <h3 className="card-title fs-20 mb-0">Categories</h3>
                </div>
                <div className="card-body px-0 pt-4 pb-0">
                  <ul className="list-unstyled mb-0">
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Sweaters
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Beauty
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Fashion
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Shopping
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Trends
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="card border-0 mb-7">
                <div className="card-header bg-transparent border-0 p-0">
                  <h3 className="card-title fs-20 mb-0">Price</h3>
                </div>
                <div className="card-body px-0 pt-4 pb-0">
                  <ul className="list-unstyled mb-0">
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        All
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        $10 - $100
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        $100 - $200
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        $200 - $300
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        $300 - $400
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="card border-0 mb-7">
                <div className="card-header bg-transparent border-0 p-0">
                  <h3 className="card-title fs-20 mb-0">Material</h3>
                </div>
                <div className="card-body px-0 pt-4 pb-0">
                  <ul className="list-unstyled mb-0">
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Laminate
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Acrylic
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Aluminium
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Cotton
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Leather
                      </a>
                    </li>
                    <li className="mb-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Metal
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="card border-0 mb-7 widget-color">
                <div className="card-header bg-transparent border-0 p-0">
                  <h3 className="card-title fs-20 mb-0">Colors</h3>
                </div>
                <div className="card-body px-0 pt-4 pb-0">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="/#" className="d-block item" style={{ backgroundColor: " #d0a272" }}>
                        {" "}
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href="/#" className="d-block item" style={{ backgroundColor: " #68412d" }}>
                        {" "}
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href="/#" className="d-block item" style={{ backgroundColor: " #000000" }}>
                        {" "}
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href="/#" className="d-block item" style={{ backgroundColor: " #aa5959" }}>
                        {" "}
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href="/#" className="d-block item" style={{ backgroundColor: " #8db4d2" }}>
                        {" "}
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href="/#" className="d-block item" style={{ backgroundColor: " #c2c3a0" }}>
                        {" "}
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href="/#" className="d-block item" style={{ backgroundColor: " #c7857d" }}>
                        {" "}
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href="/#" className="d-block item" style={{ backgroundColor: " #e3e1e7" }}>
                        {" "}
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href="/#" className="d-block item" style={{ backgroundColor: " #b490b0" }}>
                        {" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="card border-0 mb-7">
                <div className="card-header bg-transparent border-0 p-0">
                  <h3 className="card-title fs-20 mb-0">Tags</h3>
                </div>
                <div className="card-body px-0 pt-3 pb-0">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item mr-2 py-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Vintage
                      </a>
                    </li>
                    <li className="list-inline-item mr-2 py-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Awesome
                      </a>
                    </li>
                    <li className="list-inline-item mr-2 py-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Summer
                      </a>
                    </li>
                    <li className="list-inline-item mr-2 py-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Beachwear
                      </a>
                    </li>
                    <li className="list-inline-item mr-2 py-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Sunglasses
                      </a>
                    </li>
                    <li className="list-inline-item mr-2 py-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Winter
                      </a>
                    </li>
                    <li className="list-inline-item mr-2 py-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Shorts
                      </a>
                    </li>
                    <li className="list-inline-item mr-2 py-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Cool
                      </a>
                    </li>
                    <li className="list-inline-item mr-2 py-1">
                      <a href="/#" className="text-secondary hover-primary border-bottom border-white border-hover-primary d-inline-block lh-12">
                        Nice
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-footer border-0 bg-transparent pt-5 px-8">
              <div className="row no-gutter mx-n2">
                <div className="col-sm-6 px-2 mb-2 mb-sm-0">
                  <a href="/#" className="btn btn-primary btn-block letter-spacing-05 text-uppercase">
                    apply
                  </a>
                </div>
                <div className="col-sm-6 px-2">
                  <a href="/#" className="btn btn-outline-primary btn-block letter-spacing-05 text-uppercase">
                    clear
                  </a>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default ProductFilter;
